export default __webpack_public_path__ + "static/media/user1.29c54524.png";